<template lang="pug">
  div.points-info-content( v-platform-expose="moduleExpose" )
    .points-title 我的奖励金
    .points-area(@click="goBountyRecord")
      div.points-amount-container
        .points-amount {{ bountyLoaded ? points : '--' }}
        .bounty-amount 可抵{{ bountyLoaded ? bounty : '--' }}元
        img.arrow-icon(
          src="https://m.hellobike.com/235c8e9e_Polygon%202%20(1).png"
        )

    //- .tip-area
      highlight-text.tip-text(
        text="完成任务得奖励金，0元兑卡券"
        :normalStyle="normalStyle"
        :highlightStyle="{ ...normalStyle }"
      )
</template>

<script>
import { jumpUrl } from '@/utils/tools';
import config from '@/const/config';
import SPM from '@/pages/welfare/common/spm';
import highlightText from '@/components/highlight-text';

export default {
  name: 'TabPointsInfo',
  components: {
    highlightText,
  },
  props: {
    // 积分
    points: {
      type: Number,
      default: 0,
    },
    // 可抵额度
    bounty: {
      type: Number,
      default: 0,
    },
    // 奖励金加载状态
    bountyLoaded: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      // normalStyle: {
      //   fontSize: '0.12rem',
      //   color: '#593D2B',
      //   fontWeight: '400',
      // },
    };
  },
  methods: {
    moduleExpose() {
      // 奖励金信息模块曝光埋点
      SPM.moduleExpose({
        moduleId: 'my_bonus_new',
        contentId: 'my_bonus_new',
        businessInfo: {},
      });
    },
    // 跳转奖励金记录页面
    goBountyRecord() {
      SPM.clickButton({
        buttonName: 'my_bonus_new',
        businessInfo: {},
      });
      jumpUrl(
        `https://m.hellobike.com/AppPlatformH5/${
          config.env !== 'pro' ? `${config.env}/` : ''
        }latest/index.html#/bounty/exchange?adsource=1`,
      );
    },
  },
};
</script>

<style lang="less" scoped>
.points-info-content {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  margin-top: -0.04rem;

  // .tip-area {
  //   border-radius: 0.04rem;
  //   height: 0.12rem;
  //   display: flex;
  //   justify-content: center;
  //   align-items: center;
  //   align-self: flex-start; // 根据内容自适应宽度
  //   margin-top: 0.04rem;

  //   .tip-text {
  //     font-size: 0.12rem;
  //     font-weight: 400;
  //     color: #593d2b;
  //     display: flex;
  //     align-items: center;
  //     white-space: nowrap;
  //   }
  // }

  .points-title {
    font-family: PingFang SC, sans-serif;
    font-weight: 400;
    font-size: 0.12rem;
    // line-height: 12px;
    // letter-spacing: 0;
    color: #593d2b;
    margin-bottom: 0.02rem;
  }

  .points-area {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;

    .points-title {
      font-size: 0.12rem;
      line-height: 0.16rem;
      height: 0.16rem;
      font-weight: 400;
      color: #1c1917;
    }

    .points-amount-container {
      display: flex;
      align-items: flex-end;
      flex-wrap: nowrap;
      color: #1c1917;

      .points-amount {
        font-family: 'DIN Alternate Bold', sans-serif;
        font-weight: bold;
        font-size: 0.28rem;
        display: flex;
        align-items: center;
        height: 0.34rem;
        line-height: 0.34rem;
      }

      .arrow-icon {
        margin-left: 0.04rem;
        width: 0.04rem;
        height: 0.07rem;
        margin-bottom: 0.11rem;
      }

      .bounty-amount {
        font-size: 0.12rem;
        font-weight: 400;
        height: 0.22rem;
        line-height: 0.22rem;
        margin-left: 0.05rem;
        margin-bottom: 0.03rem;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        max-width: 0.74rem;
      }
    }
  }
}
</style>
